import React from "react";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  return (
    <footer className="footer-bg footer-p">
      <div
        className="footer-top pt-90 pb-40"
        style={{
          backgroundColor: "#644222",
          backgroundImage: "url(/img/bg/footer-bg.png)",
          backgroundSize: "cover",
        }}
      >
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-xl-4 col-lg-4 col-sm-6">
              <div className="footer-widget mb-30">
                <div className="f-widget-title mb-30">
                  <img src="/images/logo.png" alt="img" />
                </div>
                <div className="f-contact">
                  <ul>
                    <li>
                      <i className="icon fal fa-phone"></i>
                      <span>
                        +91 9619575411 / +91 9167903060 / +91 9987650780
                      </span>
                    </li>
                    <li>
                      <i className="icon fal fa-envelope"></i>
                      <span>
                        {" "}
                        <Link to="/enquiry">bangtanloungebiz@gmail.com</Link>
                      </span>
                    </li>
                    <li>
                      <i className="icon fal fa-map-marker-check"></i>
                      <span>
                        Ostwal Point Building, A Wing 1 / 101, Laxmi Park
                        Circle, beverly Park road, Unique Gardens, Next to BTS
                        Cafe, Mira Road East, Thane - 401107.
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xl-2 col-lg-2 col-sm-6">
              <div className="footer-widget mb-30">
                <div className="f-widget-title">
                  <h2>Our Links</h2>
                </div>
                <div className="footer-link">
                  <ul>
                    <li>
                      <Link to="/"> Home</Link>
                    </li>
                    <li>
                      <Link to="/about"> About Us</Link>
                    </li>
                    <li>
                      <Link to="/events-and-media"> Event & Media</Link>
                    </li>
                    <li>
                      <Link to="/contact"> Contact Us</Link>
                    </li>
                    <li>
                      <Link to="/enquiry"> Enquiry</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xl-2 col-lg-2 col-sm-6">
              <div className="footer-widget mb-30">
                <div className="f-widget-title">
                  <h2>Our Facilities</h2>
                </div>
                <div className="footer-link">
                  <ul>
                    <li>
                      <Link to="/restaurant">Bar & Restaurant</Link>
                    </li>
                    <li>
                      <Link to="/family-lounge">Lounge</Link>
                    </li>
                    <li>
                      <Link to="/night-club">Club</Link>
                    </li>
                    <li>
                      <Link to="/birthday-party">Event</Link>
                    </li>
                    <li>
                      <Link to="/corporate-party">Party</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 col-sm-6">
              <div className="footer-widget mb-30">
                <div className="f-widget-title">
                  <h2>Reach Us</h2>
                </div>
                <div className="footer-link">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15062.778776315803!2d72.8750765!3d19.2956387!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b1791a9ba23b%3A0xb4712837df0bda6d!2sBangtan%20lounge!5e0!3m2!1sen!2sin!4v1678266936494!5m2!1sen!2sin"
                    width="100%"
                    height="200"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright-wrap">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6">
              <span className="cpy-text">
                <span className="text-white">
                  Designed & Hosted by : Starz Ventures
                </span>
              </span>
            </div>
            <div className="col-lg-6 col-md-6 text-right text-xl-right">
              <div className="footer-social">
                <a
                  href="https://www.facebook.com/bangtanlounge"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a
                  href="https://www.instagram.com/bangtan_lounge/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-instagram"></i>
                </a>
                <a
                  href="https://wa.me/9619575411"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-whatsapp"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
